exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div{display:flex;flex-direction:column;flex-shrink:0;min-width:0;align-items:stretch}button,input{background:none;border:none;outline:none}pre{@media (max-width:550px){white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word}}body{@media (max-width:550px){overflow:hidden;width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/reset.css
// module id = ./src/reset.css
// module chunks = 8